module.exports = __webpack_public_path__ + "static/img/ad.26c76f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ad.png
// module id = 2apl
// module chunks = 7